import { IProgressUpdate, ProgressUpdate } from "./ProgressUpdate";
import { IEntity } from "./Entity";
import { ISignOff } from "./SignOff";
import { IHyperlink } from "./Hyperlink";

export interface IRiskUpdate extends IProgressUpdate {
    RiskID?: number | null;
    RiskProbabilityID: number | null;
    RiskImpactLevelID: number | null;
    Escalate: boolean;
    EscalateToRiskRegisterID: number | null;
    DeEscalate: boolean;
    RiskMitigationActionUpdates: string | null;
    SendNotifications: boolean;
    RiskRegisterID: number | null;
    RiskProximity: Date | null;
    RiskCode: string;
    RiskIsOngoing: boolean | null;
    SignOffID: number | null;
    RiskAppetiteBreachAuthorised: boolean;
    RiskProbability?: IEntity | null;
    RiskImpactLevel?: IEntity | null;
    RiskRegister?: IEntity;
    SignOff?: ISignOff;
    Narrative: string;
    ClosureReason: string;
    Attachments?: IHyperlink[];
    ToBeDiscussed?: boolean;
    DiscussionForum?: string[];
}

export class RiskUpdate extends ProgressUpdate implements IRiskUpdate {
    public RiskID? : number | null = null;
    public RiskProbabilityID = null;
    public RiskImpactLevelID = null;
    public Escalate = false;
    public EscalateToRiskRegisterID = null;
    public DeEscalate = false;
    public RiskMitigationActionUpdates = null;
    public SendNotifications = false;
    public RiskRegisterID = null;
    public RiskProximity = null;
    public RiskCode = '';
    public RiskIsOngoing = null;
    public SignOffID = null;
    public RiskAppetiteBreachAuthorised = false;
    public RiskProbability = null;
    public RiskImpactLevel = null;
    public Narrative = '';
    public ClosureReason = '';
    public UpdateUser = null;
    public Attachments = [];
    public ToBeDiscussed = false;
    public DiscussionForum = [];

    constructor(riskId?: number, period?: Date) {
        super(period);
        this.RiskID = riskId;
    }
}